import { theme } from '@prophecy/theme';
import styled from 'styled-components';
import { TabsTrigger } from '../../Tabs';
import { Text } from '../../Typography';
import { NoWrapStackItemBase } from '../sharedStyled';
import { tokens } from '../tokens';
export const HorizontalStepBase = styled(TabsTrigger) `
  margin: ${tokens.StepList.horizontal.spacing.margin};
  padding: ${tokens.StepList.horizontal.spacing.padding};
  background: ${tokens.StepList.horizontal.background};
  inset: -1px;
`;
export const HorizontalSeparator = styled.div `
  align-self: stretch;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: ${theme.spaces.x12};
`;
export const HorizontalNoWrapStackItem = styled(NoWrapStackItemBase) `
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const StyledStepNumber = styled(Text) `
  width: ${({ $size }) => tokens.IconSize[$size].fontSize};
  height: ${theme.sizes.x24};
  display: flex;
  align-items: center;
  justify-content: center;
`;
